module.exports = __webpack_public_path__ + "img/icon_2.2f35d7cc.svg";